import { Dispatch } from 'redux';
import { getErrorJson } from '@mm/utils';
import commonHandler, { ResponseOrError } from './common-handler';
import { StoreState } from '../store-interfaces';
import GoogleSheetsCRUDActions from '../actions/GoogleSheetsCRUDActions';

const INSUFFCIENT_PERMISSIONS = 1320;

export const googleSheetsHandler =
  (dispatch: Dispatch<StoreState>) =>
  async ({ error }: { error: ResponseOrError }) => {
    const json = error instanceof Response && (await getErrorJson(error));
    const { error_code: code } = json || {};

    const requestPermissions = async () => {
      const oAuthURL = await dispatch(
        GoogleSheetsCRUDActions.getOauthUrl(window.location.href),
      );
      window.open(oAuthURL, '_self');
    };

    switch (code) {
      case INSUFFCIENT_PERMISSIONS:
        requestPermissions();
        dispatch(GoogleSheetsCRUDActions.unbusy());
        break;
      default:
        return commonHandler(dispatch)(error);
    }
  };
